import { createApi } from '@reduxjs/toolkit/query/react'
import { url } from 'inspector'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const FlightAPI = createApi({
  reducerPath: 'FlightAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Flights'],
  endpoints: builder => ({
    postFlightsCompany: builder.mutation({
      query: body => ({
        url: `/api/Flights/company`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Flights'],
    }),
    postTravelDetails: builder.mutation({
      query: body => ({
        method: 'POST',
        url: `/api/Flights/company/${body.id}/travels`,
        headers: authHeaderAPI(),
        body: body.data,
      }),
      invalidatesTags: ['Flights'],
    }),
    getTravelDetails: builder.query({
      query: params => ({
        url: `/api/Flights/companies`,
        method: 'GET',
        params,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Flights'],
    }),
    deleteTravelDetails: builder.mutation({
      query: id => ({
        method: 'DELETE',
        url: `/api/Flights/company/${id}`,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Flights'],
    }),
    getTravelDetailsById: builder.query({
      query: id => ({
        method: 'GET',
        url: `/api/Flights/${id}`,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Flights'],
    }),
    updateFlightsCompany: builder.mutation({
      query: body => ({
        method: 'PUT',
        url: `/api/Flights/company/${body.Id}`,
        headers: authHeaderAPI(),
        body,
      }),
      invalidatesTags: ['Flights'],
    }),
    updateTravelDetails: builder.mutation({
      query: body => ({
        method: 'PUT',
        url: `/api/Flights/company/${body.id}/travels`,
        headers: authHeaderAPI(),
        body: body.data,
      }),
      invalidatesTags: ['Flights'],
    }),
    getAllTravelsFlights: builder.query({
      query: (params: any) => ({
        url: `/api/Flights/travels`,
        method: 'GET',
        headers: authHeaderAPI(),
        params,
      }),
      providesTags: ['Flights'],
    }),
  }),
})
export const {
  usePostFlightsCompanyMutation,
  usePostTravelDetailsMutation,
  useGetTravelDetailsQuery,
  useDeleteTravelDetailsMutation,
  useGetTravelDetailsByIdQuery,
  useUpdateFlightsCompanyMutation,
  useUpdateTravelDetailsMutation,
  useGetAllTravelsFlightsQuery,
} = FlightAPI
